export default "__VITE_ASSET__RpYXZKXI__"